type Languages = {
  name: string
  code: string
  languageBody: LanguageBody
}

type LanguageBody = {
  option_name: string
}

type LanguageConfig = {
  option_name: string
  languages: Languages[]
}
export const OPTION_LANGUAGES: LanguageConfig[] = [
  {
    option_name: 'Yes',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Yes',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Sí',
        },
      },
      {
        name: 'Deutsch',
        code: 'de-DE',
        languageBody: {
          option_name: 'Ja',
        },
      },
      {
        name: 'Français',
        code: 'fr-FR',
        languageBody: {
          option_name: 'Oui',
        },
      },
      {
        name: 'हिन्दी',
        code: 'hi-IN',
        languageBody: {
          option_name: 'हाँ',
        },
      },
      {
        name: 'Português',
        code: 'pt-BR',
        languageBody: {
          option_name: 'Sim',
        },
      },
      {
        name: 'العربية',
        code: 'ar-XA',
        languageBody: {
          option_name: 'نعم',
        },
      },
      {
        name: 'Bahasa Indonesia',
        code: 'id-ID',
        languageBody: {
          option_name: 'Ya',
        },
      },
      {
        name: 'Italiano',
        code: 'it-IT',
        languageBody: {
          option_name: 'Sì',
        },
      },
      {
        name: '日本語',
        code: 'ja-JP',
        languageBody: {
          option_name: 'はい',
        },
      },
      {
        name: 'Türkçe',
        code: 'tr-TR',
        languageBody: {
          option_name: 'Evet',
        },
      },
      {
        name: 'Tiếng Việt',
        code: 'vi-VN',
        languageBody: {
          option_name: 'Có',
        },
      },
      {
        name: 'বাংলা',
        code: 'bn-IN',
        languageBody: {
          option_name: 'হ্যাঁ',
        },
      },
      {
        name: 'ગુજરાતી',
        code: 'gu-IN',
        languageBody: {
          option_name: 'હા',
        },
      },
      {
        name: 'ಕನ್ನಡ',
        code: 'kn-IN',
        languageBody: {
          option_name: 'ಹೌದು',
        },
      },
      {
        name: 'മലയാളം',
        code: 'ml-IN',
        languageBody: {
          option_name: 'അതെ',
        },
      },
      {
        name: 'मराठी',
        code: 'mr-IN',
        languageBody: {
          option_name: 'होय',
        },
      },
      {
        name: 'தமிழ்',
        code: 'ta-IN',
        languageBody: {
          option_name: 'ஆம்',
        },
      },
      {
        name: 'తెలుగు',
        code: 'te-IN',
        languageBody: {
          option_name: 'అవును',
        },
      },
      {
        name: 'Nederlands',
        code: 'nl-NL',
        languageBody: {
          option_name: 'Ja',
        },
      },
      {
        name: '한국어',
        code: 'ko-KR',
        languageBody: {
          option_name: '예',
        },
      },
      {
        name: '官话',
        code: 'cmn-CN',
        languageBody: {
          option_name: '是',
        },
      },
      {
        name: 'Polski',
        code: 'pl-PL',
        languageBody: {
          option_name: 'Tak',
        },
      },
      {
        name: 'Русский',
        code: 'ru-RU',
        languageBody: {
          option_name: 'Да',
        },
      },
      {
        name: 'Kiswahili',
        code: 'sw-KE',
        languageBody: {
          option_name: 'Ndiyo',
        },
      },
      {
        name: 'ไทย',
        code: 'th-TH',
        languageBody: {
          option_name: 'ใช่',
        },
      },
      {
        name: 'اردو',
        code: 'ur-IN',
        languageBody: {
          option_name: 'ہاں',
        },
      },
      {
        name: 'Українська',
        code: 'uk-UA',
        languageBody: {
          option_name: 'Так',
        },
      },
    ],
  },
  {
    option_name: 'No',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'No',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'No',
        },
      },
      {
        name: 'Deutsch',
        code: 'de-DE',
        languageBody: {
          option_name: 'Nein',
        },
      },
      {
        name: 'Français',
        code: 'fr-FR',
        languageBody: {
          option_name: 'Non',
        },
      },
      {
        name: 'हिन्दी',
        code: 'hi-IN',
        languageBody: {
          option_name: 'नहीं',
        },
      },
      {
        name: 'Português',
        code: 'pt-BR',
        languageBody: {
          option_name: 'Não',
        },
      },
      {
        name: 'العربية',
        code: 'ar-XA',
        languageBody: {
          option_name: 'لا',
        },
      },
      {
        name: 'Bahasa Indonesia',
        code: 'id-ID',
        languageBody: {
          option_name: 'Tidak',
        },
      },
      {
        name: 'Italiano',
        code: 'it-IT',
        languageBody: {
          option_name: 'No',
        },
      },
      {
        name: '日本語',
        code: 'ja-JP',
        languageBody: {
          option_name: 'いいえ',
        },
      },
      {
        name: 'Türkçe',
        code: 'tr-TR',
        languageBody: {
          option_name: 'Hayır',
        },
      },
      {
        name: 'Tiếng Việt',
        code: 'vi-VN',
        languageBody: {
          option_name: 'Không',
        },
      },
      {
        name: 'বাংলা',
        code: 'bn-IN',
        languageBody: {
          option_name: 'না',
        },
      },
      {
        name: 'ગુજરાતી',
        code: 'gu-IN',
        languageBody: {
          option_name: 'ના',
        },
      },
      {
        name: 'ಕನ್ನಡ',
        code: 'kn-IN',
        languageBody: {
          option_name: 'ಇಲ್ಲ',
        },
      },
      {
        name: 'മലയാളം',
        code: 'ml-IN',
        languageBody: {
          option_name: 'ഇല്ല',
        },
      },
      {
        name: 'मराठी',
        code: 'mr-IN',
        languageBody: {
          option_name: 'नाही',
        },
      },
      {
        name: 'தமிழ்',
        code: 'ta-IN',
        languageBody: {
          option_name: 'இல்லை',
        },
      },
      {
        name: 'తెలుగు',
        code: 'te-IN',
        languageBody: {
          option_name: 'లేదు',
        },
      },
      {
        name: 'Nederlands',
        code: 'nl-NL',
        languageBody: {
          option_name: 'Nee',
        },
      },
      {
        name: '한국어',
        code: 'ko-KR',
        languageBody: {
          option_name: '아니오',
        },
      },
      {
        name: '官话',
        code: 'cmn-CN',
        languageBody: {
          option_name: '否',
        },
      },
      {
        name: 'Polski',
        code: 'pl-PL',
        languageBody: {
          option_name: 'Nie',
        },
      },
      {
        name: 'Русский',
        code: 'ru-RU',
        languageBody: {
          option_name: 'Нет',
        },
      },
      {
        name: 'Kiswahili',
        code: 'sw-KE',
        languageBody: {
          option_name: 'Hapana',
        },
      },
      {
        name: 'ไทย',
        code: 'th-TH',
        languageBody: {
          option_name: 'ไม่',
        },
      },
      {
        name: 'اردو',
        code: 'ur-IN',
        languageBody: {
          option_name: 'نہیں',
        },
      },
      {
        name: 'Українська',
        code: 'uk-UA',
        languageBody: {
          option_name: 'Ні',
        },
      },
    ],
  },
  {
    option_name: 'Why?',
    languages: [
      {name: 'English', code: 'en-US', languageBody: {option_name: 'Why?'}},
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {option_name: '¿Por qué?'},
      },
      {name: 'Deutsch', code: 'de-DE', languageBody: {option_name: 'Warum?'}},
      {
        name: 'Français',
        code: 'fr-FR',
        languageBody: {option_name: 'Pourquoi ?'},
      },
      {name: 'हिन्दी', code: 'hi-IN', languageBody: {option_name: 'क्यों?'}},
      {
        name: 'Português',
        code: 'pt-BR',
        languageBody: {option_name: 'Por quê?'},
      },
      {name: 'العربية', code: 'ar-XA', languageBody: {option_name: 'لماذا؟'}},
      {
        name: 'Bahasa Indonesia',
        code: 'id-ID',
        languageBody: {option_name: 'Kenapa?'},
      },
      {name: 'Italiano', code: 'it-IT', languageBody: {option_name: 'Perché?'}},
      {name: '日本語', code: 'ja-JP', languageBody: {option_name: 'なぜ？'}},
      {name: 'Türkçe', code: 'tr-TR', languageBody: {option_name: 'Neden?'}},
      {
        name: 'Tiếng Việt',
        code: 'vi-VN',
        languageBody: {option_name: 'Tại sao?'},
      },
      {name: 'বাংলা', code: 'bn-IN', languageBody: {option_name: 'কেন?'}},
      {name: 'ગુજરાતી', code: 'gu-IN', languageBody: {option_name: 'શા માટે?'}},
      {name: 'ಕನ್ನಡ', code: 'kn-IN', languageBody: {option_name: 'ಏಕೆ?'}},
      {
        name: 'മലയാളം',
        code: 'ml-IN',
        languageBody: {option_name: 'എന്തുകൊണ്ട്?'},
      },
      {name: 'मराठी', code: 'mr-IN', languageBody: {option_name: 'का?'}},
      {name: 'தமிழ்', code: 'ta-IN', languageBody: {option_name: 'ஏன்?'}},
      {name: 'తెలుగు', code: 'te-IN', languageBody: {option_name: 'ఎందుకు?'}},
      {
        name: 'Nederlands',
        code: 'nl-NL',
        languageBody: {option_name: 'Waarom?'},
      },
      {name: '한국어', code: 'ko-KR', languageBody: {option_name: '왜요?'}},
      {name: '官话', code: 'cmn-CN', languageBody: {option_name: '为什么？'}},
      {name: 'Polski', code: 'pl-PL', languageBody: {option_name: 'Dlaczego?'}},
      {name: 'Русский', code: 'ru-RU', languageBody: {option_name: 'Почему?'}},
      {
        name: 'Kiswahili',
        code: 'sw-KE',
        languageBody: {option_name: 'Kwa nini?'},
      },
      {name: 'ไทย', code: 'th-TH', languageBody: {option_name: 'ทำไม?'}},
      {name: 'اردو', code: 'ur-IN', languageBody: {option_name: 'کیوں؟'}},
      {name: 'Українська', code: 'uk-UA', languageBody: {option_name: 'Чому?'}},
    ],
  },
  {
    option_name: 'Skip',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Skip',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Saltar',
        },
      },
      {
        name: 'Deutsch',
        code: 'de-DE',
        languageBody: {
          option_name: 'Überspringen',
        },
      },
      {
        name: 'Français',
        code: 'fr-FR',
        languageBody: {
          option_name: 'Ignorer',
        },
      },
      {
        name: 'हिन्दी',
        code: 'hi-IN',
        languageBody: {
          option_name: 'छोड़ें',
        },
      },
      {
        name: 'Português',
        code: 'pt-BR',
        languageBody: {
          option_name: 'Pular',
        },
      },
      {
        name: 'العربية',
        code: 'ar-XA',
        languageBody: {
          option_name: 'تخطي',
        },
      },
      {
        name: 'Bahasa Indonesia',
        code: 'id-ID',
        languageBody: {
          option_name: 'Lewati',
        },
      },
      {
        name: 'Italiano',
        code: 'it-IT',
        languageBody: {
          option_name: 'Salta',
        },
      },
      {
        name: '日本語',
        code: 'ja-JP',
        languageBody: {
          option_name: 'スキップ',
        },
      },
      {
        name: 'Türkçe',
        code: 'tr-TR',
        languageBody: {
          option_name: 'Atla',
        },
      },
      {
        name: 'Tiếng Việt',
        code: 'vi-VN',
        languageBody: {
          option_name: 'Bỏ qua',
        },
      },
      {
        name: 'বাংলা',
        code: 'bn-IN',
        languageBody: {
          option_name: 'এড়িয়ে যান',
        },
      },
      {
        name: 'ગુજરાતી',
        code: 'gu-IN',
        languageBody: {
          option_name: 'છોડી દો',
        },
      },
      {
        name: 'ಕನ್ನಡ',
        code: 'kn-IN',
        languageBody: {
          option_name: 'ಬಿಟ್ಟುಬಿಡಿ',
        },
      },
      {
        name: 'മലയാളം',
        code: 'ml-IN',
        languageBody: {
          option_name: 'അവഗണിക്കുക',
        },
      },
      {
        name: 'मराठी',
        code: 'mr-IN',
        languageBody: {
          option_name: 'वगळा',
        },
      },
      {
        name: 'தமிழ்',
        code: 'ta-IN',
        languageBody: {
          option_name: 'தவிர்',
        },
      },
      {
        name: 'తెలుగు',
        code: 'te-IN',
        languageBody: {
          option_name: 'దాటవేయి',
        },
      },
      {
        name: 'Nederlands',
        code: 'nl-NL',
        languageBody: {
          option_name: 'Overslaan',
        },
      },
      {
        name: '한국어',
        code: 'ko-KR',
        languageBody: {
          option_name: '건너뛰기',
        },
      },
      {
        name: '官话',
        code: 'cmn-CN',
        languageBody: {
          option_name: '跳过',
        },
      },
      {
        name: 'Polski',
        code: 'pl-PL',
        languageBody: {
          option_name: 'Pomiń',
        },
      },
      {
        name: 'Русский',
        code: 'ru-RU',
        languageBody: {
          option_name: 'Пропустить',
        },
      },
      {
        name: 'Kiswahili',
        code: 'sw-KE',
        languageBody: {
          option_name: 'Ruka',
        },
      },
      {
        name: 'ไทย',
        code: 'th-TH',
        languageBody: {
          option_name: 'ข้าม',
        },
      },
      {
        name: 'اردو',
        code: 'ur-IN',
        languageBody: {
          option_name: 'چھوڑ دیں',
        },
      },
      {
        name: 'Українська',
        code: 'uk-UA',
        languageBody: {
          option_name: 'Пропустити',
        },
      },
    ],
  },
  {
    option_name: 'Married',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Married',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Casado/a',
        },
      },
    ],
  },
  {
    option_name: 'Single',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Single',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Soltero/a',
        },
      },
    ],
  },
  {
    option_name: 'Divorced',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Divorced',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Divorciado/a',
        },
      },
    ],
  },
  {
    option_name: 'Separated',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Separated',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Separado/a',
        },
      },
    ],
  },
  {
    option_name: 'Widowed',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Widowed',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Viudo/a',
        },
      },
    ],
  },
  {
    option_name: 'Unknown',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Unknown',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Desconocido',
        },
      },
    ],
  },
  {
    option_name: '$0',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: '$0',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: '$0',
        },
      },
    ],
  },
  {
    option_name: '$1-$1,600/Month',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: '$1-$1,600/Month',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: '$1-$1,600/Mes',
        },
      },
    ],
  },
  {
    option_name: '$1,601-$4,000/Month',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: '$1,601-$4,000/Month',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: '$1,601-$4,000/Mes',
        },
      },
    ],
  },
  {
    option_name: '$4,001+/Month',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: '$4,001+/Month',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: '$4,001+/Mes',
        },
      },
    ],
  },
  {
    option_name: 'Male',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Male',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Masculino',
        },
      },
    ],
  },
  {
    option_name: 'Female',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Female',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Femenino',
        },
      },
    ],
  },
  {
    option_name: 'Other',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Other',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Otro',
        },
      },
    ],
  },
  {
    option_name: 'Weekly',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Weekly',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Semanal',
        },
      },
    ],
  },
  {
    option_name: 'Biweekly',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Biweekly',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Cada dos semanas',
        },
      },
    ],
  },
  {
    option_name: 'Twice a month',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Twice a month',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Dos veces al mes',
        },
      },
    ],
  },
  {
    option_name: 'Monthly',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Monthly',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Mensual',
        },
      },
    ],
  },
  {
    option_name: 'Lump sum',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Lump sum',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Pago único',
        },
      },
    ],
  },
  {
    option_name: 'Food',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Food',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Comida',
        },
      },
    ],
  },
  {
    option_name: 'Shelter',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Shelter',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Refugio',
        },
      },
    ],
  },
  {
    option_name: 'Cash',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Cash',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Efectivo',
        },
      },
    ],
  },
  {
    option_name: 'Spouse',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Spouse',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Esposo/a',
        },
      },
    ],
  },
  {
    option_name: 'Child',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Child',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Hijo/a',
        },
      },
    ],
  },
  {
    option_name: 'Stepchild',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Stepchild',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Hijastro/a',
        },
      },
    ],
  },
  {
    option_name: 'Sibling/step-sibling',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Sibling/step-sibling',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Hermano/a o hermanastro/a',
        },
      },
    ],
  },
  {
    option_name: 'Stepparent',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Stepparent',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Padrastro o madrastra',
        },
      },
    ],
  },
  {
    option_name: 'Parent/legal guardian',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Parent/legal guardian',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Padre/madre o tutor legal',
        },
      },
    ],
  },
  {
    option_name: 'Salary/Wage (has paystub)',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Salary/Wage (has paystub)',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Salario/Sueldo (con talón de pago)',
        },
      },
    ],
  },
  {
    option_name: 'Self employed/Business owner',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Self employed/Business owner',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Trabajador por cuenta propia/Dueño de negocio',
        },
      },
    ],
  },
  {
    option_name: 'Unemployment Compensation',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Unemployment Compensation',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Compensación por desempleo',
        },
      },
    ],
  },
  {
    option_name: 'Public Assistance',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Public Assistance',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Asistencia pública',
        },
      },
    ],
  },
  {
    option_name: 'Pension',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Pension',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Pensión',
        },
      },
    ],
  },
  {
    option_name: 'No Income',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'No Income',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Sin ingresos',
        },
      },
    ],
  },
  {
    option_name: 'Cash',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Cash',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Efectivo',
        },
      },
    ],
  },
  {
    option_name: 'Checking account',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Checking account',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Cuenta corriente',
        },
      },
    ],
  },
  {
    option_name: 'Savings account',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Savings account',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Cuenta de ahorros',
        },
      },
    ],
  },
  {
    option_name: 'Certificates of deposit/IRA',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Certificates of deposit/IRA',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Certificados de depósito/IRA',
        },
      },
    ],
  },
  {
    option_name: 'Primary tax filer (not filing jointly)',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Primary tax filer (not filing jointly)',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name:
            'Declarante principal de impuestos (no declara en conjunto)',
        },
      },
    ],
  },
  {
    option_name: 'Filing jointly with spouse',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Filing jointly with spouse',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Declaración conjunta con el cónyuge',
        },
      },
    ],
  },
  {
    option_name: 'Tax dependent',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Tax dependent',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'Dependiente fiscal',
        },
      },
    ],
  },
  {
    option_name: 'Not planning to file tax',
    languages: [
      {
        name: 'English',
        code: 'en-US',
        languageBody: {
          option_name: 'Not planning to file tax',
        },
      },
      {
        name: 'Español',
        code: 'es-US',
        languageBody: {
          option_name: 'No planea declarar impuestos',
        },
      },
    ],
  },
]
